export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: "/downloads",
    name: "Downloads",
    slug: "downloads",
    icon: "DownloadIcon",
  },
  {
    url: "/sdk-license",
    name: "NFCRead SDK Key",
    slug: "sdkLicense",
    icon: "SmartphoneIcon",
  },
  {
    url: "/api-license",
    name: "FaceRead Web API",
    slug: "apiLicense",
    icon: "GlobeIcon",
  },
  {
    url: "/page2",
    name: "Liveness Web API",
    slug: "Liveness",
    icon: "HeartIcon",
  },
  {
    url: "/knowledgeBase",
    name: "Knowledge Base",
    slug: "knowledgeBase",
    icon: "InfoIcon",
  },
  {
    url: "/users-list",
    name: "Users",
    slug: "usersList",
    icon: "UsersIcon",
    rule: 'SuperAdmin'
    
  },
  {
    url: "/products-list",
    name: "Products",
    slug: "productsList",
    icon: "PlusCircleIcon",
    rule: 'SuperAdmin'
    
  },
  {
    url: "/packages-list",
    name: "Packages",
    slug: "packagesList",
    icon: "ArchiveIcon",
    rule: 'SuperAdmin'
    
  },
  {
    url: "/bank-accounts",
    name: "Bank Accounts",
    slug: "bankAccounts",
    icon: "DollarSignIcon",
    rule: 'SuperAdmin'
    
  },
  {
    url: "/licenses",
    name: "Licenses",
    slug: "licenses",
    icon: "CheckSquareIcon",
    rule: 'SuperAdmin'
    
  },
  {
    url: "/orders",
    name: "Orders",
    slug: "orders",
    icon: "CreditCardIcon",
  },
  {
    url: "/account-detail",
    name: "Account Detail",
    slug: "accountDetail",
    icon: "SettingsIcon",
    submenu:[
      {
        url: "/account-detail",
        name: "Account Detail",
        slug: "accountDetail",
        icon: "SettingsIcon",
      },
      {
        url: "/renew-password",
        name: "Change Password",
        slug: "changePassword",
        icon: "LockIcon",
      }
    ]
  },
  {
    url: "/reports",
    name: "Reports",
    slug: "resports",
    icon: "FileTextIcon",
  },
 
]
